import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';

export const clinicFormPanel = new EoFormPanelConfig({
  name: 'clinic',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'hospitalID',
      label: 'Νοσοκομείο',
      styleClass: 'col-6',
      control: new FormControl(null, [Validators.required])
    }),
    new EoCustomControlConfig({
      name: 'userID',
      label: 'Διαχειριστής Κλινικής',
      styleClass: 'col-6',
      control: new FormControl(null, [Validators.required])
    }),
    new EoInputConfig({
      name: 'clinicName',
      styleClass: 'col-12',
      type: 'text',
      label: 'Επωνυμία Κλινικής',
      control: new FormControl('', [Validators.required]),
      placeholder: 'Παρακαλώ συμπληρώστε την επωνυμία της κλινικής',
      inputIcon: 'pi pi-building',
    }),
    new EoInputConfig({
      name: 'clinicFirstPhone',
      styleClass: 'col-6',
      type: 'text',
      label: 'Τηλέφωνο Επικοινωνίας',
      placeholder: 'Παρακαλώ συμπληρώστε το τηλέφωνο επικοινωνίας',
      control: new FormControl(null),
    }),
 
    new EoInputConfig({
      name: 'clinicSecondPhone',
      styleClass: 'col-6',
      type: 'text',
      label: 'Επιπλέον Τηλέφωνο',
      placeholder: 'Συμπληρώστε το επιπλέον τηλέφωνο (προαιρετικά)',
      control: new FormControl(null),
    })
  ],
});

export const clinicFormConfig: EoFormPanelConfig[] = [clinicFormPanel];





